import { DataTable, Dialog } from "@/components";
import { CommunityDialogProps } from "./types";
import useCommunityDialog from "./useCommunityDialog";

const CommunityDialog = ({
  open,
  setOpen,
  selectedRow,
}: CommunityDialogProps) => {
  const { columns } = useCommunityDialog();
  return (
    <Dialog
      open={open}
      setOpen={setOpen}
      title={<div className="text-2xl font-bold text-primary">
          {`Associated Communities - ${selectedRow?.ownerName}`}
          <div className="h-1 w-[30%] bg-primary rounded-full" />
        </div>
      }
      contentClassName="lg:!max-w-[700px] lg:!w-[700px]"
    >
      <DataTable
        columns={columns}
        data={selectedRow?.communities || []}
        hideFooter
        className="shadow-none border-0"
        tableWrapperClassName="p-0"
      />
    </Dialog>
  )
}

export default CommunityDialog;